import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from "amazon-cognito-identity-js";

const userPool = new CognitoUserPool({
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  ClientId:   process.env.REACT_APP_COGNITO_CLIENT_ID,
});

export { userPool, CognitoUser, AuthenticationDetails };
